import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EndpointsConfigService } from './endpoints-config.service';

@Injectable({
  providedIn: 'root'
})
export class HttpClientService {

    // observe the full response
    httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      withCredentials: true,
      observe: 'response' as 'response'
    };

    constructor(private http: HttpClient, private _config: EndpointsConfigService) { }

    public makeLoginPostReq(request: any, api: string): Observable<any> {
      return this.http.post<any>((this._config.ApiUrl + api), request);
    }

    public makePostReq(request: any, api: string): Observable<any> {
      if (api.indexOf('downloadStatement') > -1) {
        return this.http.post((this._config.ApiUrl + api), request, { responseType: 'blob' });
      }
      return this.http.post<any>((this._config.ApiUrl + api), request, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), withCredentials: true });
    }

    public makeFileUploadPostReq(request: any, api: string): Observable<any> {
      this.setFileUploadHeaders();
      return this.http.post((this._config.ApiUrl + api), request);
    }

    private setFileUploadHeaders() {
      let headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
    }

    public makeGetReq(api: string, params = {}): Observable<any> {
      if(api.indexOf('download/attachments')>-1){
        return this.http.get((this._config.ApiUrl + api),{responseType: 'blob'});
      }
      return this.http.get((this._config.ApiUrl + api), { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT' }), params: params});
    }

    public makeMockGetReq(api: string): Observable<any> {
      return this.http.get((api), { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT' }) });
    }

    public makeMockFileUploadPostReq(request: any, api: string): Observable<any> {
      this.setFileUploadHeaders();
      return this.http.post((api), request);
    }

    public makeMockPostReq(request: any, api: string): Observable<any> {
      if (api.indexOf('downloadStatement') > -1) {
        return this.http.post((this._config.ApiUrl + api), request, { responseType: 'blob' });
      }
      return this.http.post<any>((api), request, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), withCredentials: true });
    }

    public makePutReq(request: any, api: string): Observable<any> {
      return this.http.put<any>((this._config.ApiUrl + api), request, { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), withCredentials: true });
    }

    public makeGetReqTemp(api: string): Observable<any> {
      return this.http.get((api), { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache', 'Pragma': 'no-cache', 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT' }) });
    }

    public makeDeleteReq(api: string): Observable<any> {
      return this.http.delete<any>((this._config.ApiUrl + api), { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), withCredentials: true });
    }

    /**
     * Convert Object to HttpParams
     * @param {Object} obj
     * @returns {HttpParams}
     */
    toHttpParams(obj: any): HttpParams {
      return Object.getOwnPropertyNames(obj)
        .reduce((p, key) => p.set(key, obj[key]), new HttpParams());
    }

    public makePostReqForFileDownload(request: any, api: string, params: any = {}): Observable<any> {
        return this.http.post((this._config.ApiUrl + api), request, { responseType: 'blob',params: params });
    }
}
